export type HelpCenterTutorialVideo = {
  id: number;
  title: string;
  description: string;
  videoUrl: string;
};

export type HelpCenterTutorialCategory = {
  path: string;
  title: string;
  videos: HelpCenterTutorialVideo[];
};

export type HelpCenterImportTemplate = {
  id: string;
  title: string;
  description: string;
  href: string;
  downloadName: string;
};

export const HELP_CENTER_HOME_VIDEO = {
  title: 'Conheça o Sienge eCustos',
  videoUrl: 'https://player.vimeo.com/video/913049090',
};

export const HELP_CENTER_TUTORIALS_BY_ROUTE: Record<
  string,
  HelpCenterTutorialCategory
> = {
  '/budgets/tutorial': {
    path: '/budgets/tutorial',
    title: 'Tutoriais - Orçamentos',
    videos: [
      {
        id: 1,
        title: 'Criação da tabela no Sienge',
        description: 'Veja como criar uma tabela de integração no Sienge.',
        videoUrl: 'https://player.vimeo.com/video/913046340',
      },
      {
        id: 2,
        title: 'Criação da obra e unidades construtivas',
        description:
          'Agora, você precisa criar a obra e as unidades construtivas no Sienge.',
        videoUrl: 'https://player.vimeo.com/video/913047350',
      },
      {
        id: 3,
        title: 'Orçamento',
        description:
          'Veja como criar um orçamento no eCustos e integrar com o Sienge.',
        videoUrl: 'https://player.vimeo.com/video/913049433',
      },
      {
        id: 4,
        title: 'Análises no Sienge',
        description:
          'Depois de enviar o orçamento, veja como analisar os dados no Sienge.',
        videoUrl: 'https://player.vimeo.com/video/913051203',
      },
      {
        id: 5,
        title:
          'Atualização nos itens do orçamento com base nos preços originais',
        description:
          'Veja como atualizar os valores de seus orçamentos de acordo com os preços da base.',
        videoUrl: 'https://player.vimeo.com/video/1055348154',
      },
      {
        id: 6,
        title: `Importar orçamentos`,
        description: `Veja como importar seu orçamento para o eCustos a partir de um arquivo Excel`,
        videoUrl: 'https://player.vimeo.com/video/1204261704?h=40e8158a7c',
      },
    ],
  },
  '/compositions/tutorial': {
    path: '/compositions/tutorial',
    title: 'Tutorial - Serviços',
    videos: [
      {
        id: 1,
        title: 'Importação da planilha de serviços',
        description:
          'Veja como importar uma planilha de serviços para o ecustos.',
        videoUrl: 'https://player.vimeo.com/video/1150151191?h=cd95c381cb',
      },
    ],
  },
  '/imports/tutorial': {
    path: '/imports/tutorial',
    title: 'Tutorial - Importações',
    videos: [
      {
        id: 1,
        title: 'Importação de serviços',
        description:
          'Veja como importar uma planilha de serviços para o ecustos.',
        videoUrl: 'https://player.vimeo.com/video/1150151191?h=cd95c381cb',
      },
      {
        id: 2,
        title: `Importar orçamentos`,
        description: `Veja como importar seu orçamento para o eCustos a partir de um arquivo Excel`,
        videoUrl: 'https://player.vimeo.com/video/1204261704?h=40e8158a7c',
      },
    ],
  },
  '/configuration/integrations/tutorial': {
    path: '/configuration/integrations/tutorial',
    title: 'Tutoriais - Integração',
    videos: [
      {
        id: 1,
        title: 'Configurando a API',
        description: 'Veja como configurar a API para integração com o Sienge.',
        videoUrl: 'https://player.vimeo.com/video/913048142',
      },
    ],
  },
  '/inputs/tutorial': {
    path: '/inputs/tutorial',
    title: 'Tutorial - Insumos',
    videos: [
      {
        id: 1,
        title: 'Como pesquisar serviços e insumos',
        description:
          'Saiba como pesquisar e filtrar os serviços e insumos nas bases disponíveis.',
        videoUrl: 'https://player.vimeo.com/video/347581590',
      },
      {
        id: 2,
        title: 'Como adicionar serviço e insumo próprio',
        description:
          'Crie seus próprios serviços e insumos para utilizar em seus orçamentos.',
        videoUrl: 'https://player.vimeo.com/video/360797699',
      },
      {
        id: 3,
        title: 'Importação da planilha de serviços e insumos',
        description:
          'Veja como importar uma planilha de serviços para o ecustos.',
        videoUrl: 'https://player.vimeo.com/video/913050792',
      },
    ],
  },
};

export const HELP_CENTER_IMPORT_TEMPLATES: HelpCenterImportTemplate[] = [
  {
    id: 'budget-template',
    title: 'Modelo de importação de orçamento',
    description: 'Baixe a planilha para importar orçamento no formato correto.',
    href: '/files/modelo_importacao_orcamento.xlsx',
    downloadName: 'modelo_importacao_orcamento.xlsx',
  },
  {
    id: 'composition-template',
    title: 'Modelo de importação de serviços',
    description: 'Baixe a planilha para importar serviços próprios.',
    href: '/files/modelo_importacao_servicos.xlsx',
    downloadName: 'modelo_importacao_servicos.xlsx',
  },
  {
    id: 'input-template',
    title: 'Modelo de importação de insumos',
    description: 'Baixe a planilha para importar insumos próprios.',
    href: '/files/modelo_importacao_insumos.xlsx',
    downloadName: 'modelo_importacao_insumos.xlsx',
  },
];
